import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';

import { ClientFollowMappingFragment } from 'api';

import UsersRequired from './UsersRequired';
import UsersSuggested from './UsersSuggested';

interface IProps {
  mapping: ClientFollowMappingFragment;
}

const UsersEdit: FC<IProps> = ({ mapping }) => {
  const { t } = useTranslation();

  return (
    <Grid container>
      <Grid item xs={3}>
        <Typography variant="subtitle2">{t('common:person_plural')}</Typography>
      </Grid>
      <Grid item xs={9}>
        <Grid container direction="column" spacing={4}>
          <Grid item>
            <UsersRequired mapping={mapping} />
          </Grid>
          <Grid item>
            <UsersSuggested mapping={mapping} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default UsersEdit;
